import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../components/Layouts/MainLayout.vue'),
    children: [
      // { path: '', name: 'home', component: () => import('../components/Pages/Index.vue') },
      { path: '', name: 'login', component: () => import('../components/Pages/Login.vue') }
    ]
  },
  {
    path: '/dashboard',

    component: () => import('../components/Layouts/AuthLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      // { path: 'admin', name: 'adminDashboard', component: () => import('../components/Pages/DashboardAdmin.vue') },
      // { path: 'user', name: 'userDashboard', component: () => import('../components/Pages/DashboardUser.vue') }
      {
        path: 'admin',
        name: 'adminDashboard',
        component: () => import('../components/Pages/DashboardAdmin.vue'),
        redirect: 'admin/inicio',
        children: [
          { path: 'inicio', component: () => import('../components/Administrador/Inicio/InicioAdmin.vue') },
          { path: 'clientes', component: () => import('../components/Administrador/Clientes/Clientes.vue') },
          { path: 'marca', component: () => import('../components/Administrador/Marcas/Marcas.vue') },
          { path: 'modelo', component: () => import('../components/Administrador/Modelos/Modelos.vue') },
          { path: 'proveedores', component: () => import('../components/Administrador/Proveedores/Proveedores.vue') },
          { path: 'solicitudes', component: () => import('../components/Administrador/Solicitudes/Solicitudes.vue') },
          { path: 'autos', component: () => import('../components/Administrador/Autos/Autos.vue') },
          { path: 'cotizaciones', component: () => import('../components/Administrador/Cotizaciones/Cotizaciones.vue') },
          { path: 'cuentasporcobrar', component: () => import('../components/Administrador/CuentasPorCobrar/CuentasPorCobrar.vue') },
          { path: 'contratos', component: () => import('../components/Administrador/Contratos/Contratos.vue') },
          { path: 'contratos-anteriores', component: () => import('../components/Administrador/Contratos/ContratosAnteriores.vue') },
          { path: 'cuentasporpagar', component: () => import('../components/Administrador/CuentasPorPagar/CuentasPorPagar.vue') },
          { path: 'seguros', component: () => import('../components/Administrador/Seguros/Seguros.vue') },
          { path: 'facturacion', component: () => import('../components/Administrador/Facturacion/Facturacion.vue') },
          { path: 'facturacion-rfc', component: () => import('../components/Administrador/Facturacion/FacturacionPorRFC.vue') },
          { path: 'configuracion', component: () => import('../components/Administrador/Empresa/Configuracion.vue') },
          { path: 'localizadores', component: () => import('../components/Administrador/Geolocalizador/Geolocalizador.vue') },
          { path: 'facturacion-pendiente', component: () => import('../components/Administrador/FacturacionPendiente/FacturacionPendiente.vue') },
          { path: 'reportes', component: () => import('../components/Administrador/Reportes/Reportes.vue') },
          { path: 'expedientes', component: () => import('../components/Administrador/Autos/Expediente.vue') }
        ]
      },
      {
        path: 'user',
        name: 'userDashboard',
        component: () => import('../components/Pages/DashboardUser.vue'),
        redirect: 'user/catalogo',
        children: [
          { path: 'inicio', component: () => import('../components/Usuario/Inicio/InicioUser.vue') },
          { path: 'catalogo', component: () => import('../components/Usuario/Catalogo/Catalogo.vue') },
          { path: 'mis-solicitudes', component: () => import('../components/Usuario/MisSolicitudes/MisSolicitudes.vue') },
          { path: 'mis-cotizaciones', component: () => import('../components/Usuario/MisCotizaciones/MisCotizaciones.vue') },
          { path: 'cuentasporpagar', component: () => import('../components/Usuario/CuentasPorPagar/CuentasPorPagar.vue') },
          { path: 'mis-contratos', component: () => import('../components/Usuario/MisContratos/MisContratos.vue') },
          { path: 'mi-perfil', component: () => import('../components/Usuario/MiPerfil/MiPerfil.vue') },
          { path: 'mis-autos', component: () => import('../components/Usuario/MisAutos/MisAutos.vue') },
        ]
      }
    ]
  },

  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  routes
})

// Guardias de navegación
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const usuario = store.getters['auth/usuario'];

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // No autenticado, redirige a login
      return next({ name: 'login' });
    }

    // Usuario no definido o sin rol (podría ser token inválido o sesión corrupta)
    if (!usuario || !usuario.rol) {
      // Opcional: limpiar sesión y mandar a login
      store.dispatch('auth/cerrarSesion');
      return next({ name: 'login' });
    }

    // Protección por rol
    if (to.name === 'adminDashboard' && usuario.rol !== 'Administrador') {
      return next({ name: 'userDashboard' });
    }
    if (to.name === 'userDashboard' && usuario.rol !== 'Usuario') {
      return next({ name: 'adminDashboard' });
    }

    // Si todo está bien, continuar
    return next();
  }

  // Rutas que no requieren autenticación (como login o home)
  next();
});


export default router
